<template>
<div>
  <i v-show="loadingShowcase" class="icon loading" />
  <div>
    <div v-if="isArrowDisplayed" class="slide-nav slide-left">
      <i
        class="icon icon-chevron-left icon-color text-xl clickable"
        @click="slideLeft()"
      />
    </div>
    <div class="image-wrapper">
      <img v-if="isPreview" class="item-image"
        :src="`data:image/jpg;base64,${currentSlide}`"
      />
      <img v-else class="item-image"
        :src="require(`@/assets/deepsleep/${slides[activeSlide]}`)"
      />
    </div>
    <div v-if="isArrowDisplayed" class="slide-nav slide-right">
      <i
        class="icon icon-chevron-right icon-color text-xl clickable"
        @click="slideRight()"
      />
    </div>
  </div>
</div>
</template>

<script>
import AssetsApiService from '@/services/assetsServices/assetsApiService';

export default {
    props: {
    slides: {
      type: Array,
      require: true,
    },
    isPreview: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loadingShowcase: false,
      activeSlide: 0,
      currentSlide: ''
    };
  },
  watch: {
    slides() {
      this.activeSlide = 0;
    },
    activeSlide() {
      if (this.isPreview) {
        this.setCurrentSlide();
      }
    }
  },
  mounted() {
    if(this.isPreview) {
        this.setCurrentSlide();
      }
  },
  methods: {
    slideLeft() {
      this.activeSlide = this.activeSlide === 0 ? this.slides.length - 1 : this.activeSlide - 1;
    },
    slideRight() {
      this.activeSlide = this.activeSlide === this.slides.length - 1 ? 0 : this.activeSlide + 1;
    },
    activateSlide(index) {
      this.activeSlide = index;
    },
    async setCurrentSlide() {
      const slide = this.slides[this.activeSlide];
      this.currentSlide = await AssetsApiService.getAssetFile(slide);
    }
  },
  computed: {
    isArrowDisplayed() {
      return this.slides.length > 1;
    }
  }
};
</script>

<style lang="less" scoped>
@import '~@eds/vanilla/variables/dark.less';
@import '../assets/common.less';
.slide-left {
  position: absolute;
  top: 48%;
  z-index: 10;
}
.slide-right {
  position: absolute;
  top: 48%;
  left: calc(100% - 50px);
  z-index: 10;
}
.slide-nav i {
  font-size: 46px;
}
.slide-nav:hover i {
  font-size: 48px;
}
.icon-color {
  color: #0c0c0c;
}
.image-wrapper {
  text-align: center;
}
.loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.item-image {
  width: 100%;
}
</style>
